//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
      default: undefined,
    },
    buttonDisabled: {
      type: Boolean,
      required: false,
    },
  },
};
